// 로딩 UI 원자(atom). globals.css 의 .loader(브랜드 블루 #346EDA 3-dot 애니메이션)를 재사용한다.
// Spinner: 인라인 로더. LoadingScreen: 라우트 단위 Suspense fallback / 전체 화면 로딩용 로더.

interface SpinnerProps {
  className?: string;
}

export const Spinner = ({ className }: SpinnerProps) => {
  return (
    <div className="flex items-center justify-center">
      <div className={`loader ${className ?? ''}`} />
    </div>
  );
};

interface LoadingScreenProps {
  label?: string;
  className?: string;
}

export const LoadingScreen = ({ label, className }: LoadingScreenProps) => {
  return (
    <div className={`flex min-h-[60vh] w-full flex-col items-center justify-center gap-4 ${className ?? ''}`}>
      <Spinner />
      {label && <p className="text-body2Medium text-coolNeutral-40">{label}</p>}
    </div>
  );
};
